export const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(value || "").trim());

export const normalizeIndianPhone = (value) => {
  const digits = String(value || "").replace(/\D/g, "");
  if (digits.length === 10) return `+91${digits}`;
  if (digits.startsWith("91") && digits.length === 12) return `+${digits}`;
  return String(value || "").trim();
};

export const isValidIndianPhone = (value) => /^\+91[6-9]\d{9}$/.test(normalizeIndianPhone(value));

export const normalizeIndianPlate = (value) => String(value || "").replace(/[\s-]+/g, "").toUpperCase();

export const isValidIndianPlate = (value) => /^[A-Z]{2}\d{1,2}[A-Z]{1,3}\d{4}$/.test(normalizeIndianPlate(value));

export const formatIndianPlate = (value) => {
  const plate = normalizeIndianPlate(value);
  const match = plate.match(/^([A-Z]{2})(\d{1,2})([A-Z]{1,3})(\d{4})$/);
  return match ? `${match[1]}-${match[2]}-${match[3]}-${match[4]}` : plate;
};
